module.exports = __webpack_public_path__ + "img/ywyk-instructions01.5cd765ba.jpg";